/** LocalStorage key for selected installation — lives in a leaf module to avoid circular imports (Axios ↔ BaseService ↔ … ↔ InstallationContext). */
export const SELECTED_INSTALLATION_STORAGE_KEY =
  "ecoscout.selectedInstallationId";

export function readStoredInstallationId(): number {
  try {
    const s = localStorage.getItem(SELECTED_INSTALLATION_STORAGE_KEY);
    if (s == null) return 0;
    const n = Number.parseInt(s, 10);
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}

export function persistInstallationId(id: number) {
  try {
    if (id > 0) {
      localStorage.setItem(SELECTED_INSTALLATION_STORAGE_KEY, String(id));
    } else {
      localStorage.removeItem(SELECTED_INSTALLATION_STORAGE_KEY);
    }
  } catch {
    // ignore quota / private mode
  }
}

/** Clears persisted installation selection (e.g. before full reload on auth failure). */
export function clearStoredInstallationIdFromStorage() {
  try {
    localStorage.removeItem(SELECTED_INSTALLATION_STORAGE_KEY);
  } catch {
    // ignore quota / private mode
  }
}
